<template>
  <div ref="otpCont">
    <KInput
      type="text"
      class="otp"
      v-for="(el, ind) in digits"
      :key="el+ind"
      v-model="digits[ind]"
      :autofocus="ind === 0"
      maxlength="1"
      @keydown="handleKeyDown($event, ind)"
      @paste="handlePaste($event, ind)"
      :class="{bounce: digits[ind] !== null}"
      :error="error"
    />
  </div>
</template>

<script setup>
import { ref, reactive } from 'vue';
import KInput from '@components/inputs/input.vue';

const props = defineProps({
  default: String,

  digitCount: {
    type: Number,
    default: 5,
  },

  error: {
    type: Boolean,
    default: false,
  },
});

const digits = reactive([]);

if (props.default && props.default.length === props.digitCount) {
  for (let i = 0; i < props.digitCount; i += 1) {
    digits[i] = props.default.charAt(i);
  }
} else {
  for (let i = 0; i < props.digitCount; i += 1) {
    digits[i] = null;
  }
}

const otpCont = ref(null);

const emit = defineEmits(['input', 'complete']);

const checkComplete = () => {
  const otp = digits.join('');
  if (otp.length === props.digitCount && !digits.includes(null)) {
    emit('complete', otp);
  }
};

const handleKeyDown = (event, index) => {
  if (event.key !== 'Tab'
    && event.key !== 'ArrowRight'
    && event.key !== 'ArrowLeft'
    && !event.ctrlKey
    && !event.metaKey
  ) {
    event.preventDefault();
  }

  if (event.key === 'Backspace') {
    digits[index] = null;

    if (index !== 0) {
      (otpCont.value.children)[index - 1].getElementsByTagName('input')[0].focus();
    }
  } else if (event.key === 'Enter') {
    checkComplete();
  } else if ((/^([0-9])$/).test(event.key)) {
    digits[index] = event.key;

    if (index !== props.digitCount - 1) {
      (otpCont.value.children)[index + 1].getElementsByTagName('input')[0].focus();
    }

    checkComplete();
  }

  emit('input', digits.join(''));
};

const handlePaste = (event, index) => {
  event.preventDefault();
  const pasted = event.clipboardData.getData('text').replace(/\D/g, '').slice(0, props.digitCount - index);

  for (let i = 0; i < pasted.length; i += 1) {
    digits[index + i] = pasted.charAt(i);
  }

  const nextIndex = Math.min(index + pasted.length, props.digitCount - 1);
  (otpCont.value.children)[nextIndex].getElementsByTagName('input')[0].focus();

  emit('input', digits.join(''));
  checkComplete();
};
</script>

<style scoped lang="scss">
.otp {
  width: calc(var(--grid-unit) * 5);
  display: inline-block;
  margin: 0 calc(var(--grid-unit) * .5);

  @media screen and (min-width: 768px) {
    margin: 0 calc(var(--grid-unit) * 1.5);
  }

  :deep(.k-input) {
    height: 42px;
    display: inline-block;
  }
}
</style>
